export default __webpack_public_path__ + "static/media/projectsBanner.0553c44a.png";